module.exports = __webpack_public_path__ + "static/media/Data Asset Page Icons-01.4df4f2c4.svg";